// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__htWGA","content":"Consent_content__3ldPS","footer":"Consent_footer__1vAKb"};